import { Button } from '../Button';
import { StatusModal } from '../StatusModal';
type Props = {
  className?: string;
  isOpen: boolean;
  setOpen: (open: boolean) => void;
};
export const ContactSupportModal = ({
  className,
  isOpen,
  setOpen
}: Props) => {
  return <StatusModal buttonsChildren={<Button fullWIdth onClick={() => setOpen(false)}>
          Зрозуміло
        </Button>} className={className} logoStatus='smile' onOpenChange={setOpen} open={isOpen} richText={[{
    children: [{
      text: 'Для вирішення вашого питання ви можете звернутись до нас через:'
    }, {
      children: [{
        text: 'Вайбер (+380 99 00 80 654)'
      }],
      linkType: 'custom',
      type: 'link',
      url: 'tel:+380990080654'
    }, {
      children: [{
        text: 'Телеграм (+380 99 00 80 654)'
      }],
      linkType: 'custom',
      type: 'link',
      url: 'tel:+380990080654'
    }]
  }]} data-sentry-element="StatusModal" data-sentry-component="ContactSupportModal" data-sentry-source-file="ContactSupportModal.tsx" />;
};